import React from "react";

const Videos = ({ URL }) => {
  return (
    <div className="videos">
      <iframe
        className="rounded mx-auto d-flex my-5"
        width="90%"
        height="300px"
        src={URL}
      ></iframe>
    </div>
  );
};

export default Videos;
